import { useParams } from 'react-router-dom'
import { shallowEqual, useSelector } from 'react-redux'
import { hasFeature } from 'features/hocs'
import { usePermission } from 'admin/hocs'
import { BaseRouteParams } from 'hocs'
import { State } from 'store'
import { capabilitiesFor } from 'capacity/api/createCapacityGateway'
import { serverFlagsFromState } from 'capacity/reduxQuery'

export const CAPACITY_FEATURE = 'CapacitySection'

export function useCapacityAccess(accountSlug?: string): boolean {
    const { accountSlug: routeSlug } = useParams<BaseRouteParams>()
    const slug = accountSlug ?? routeSlug
    const flagOn = useSelector((state: State) =>
        hasFeature({
            accountSlug: slug,
            features: state.features,
            featureName: CAPACITY_FEATURE,
            conviousAdmin: state.auth.user?.isAdmin ?? false,
        }),
    )
    const { hasPermission } = usePermission()
    return flagOn && hasPermission('partner_admin', slug)
}

export function useCapacityCapabilities(accountSlug?: string) {
    const { accountSlug: routeSlug } = useParams<BaseRouteParams>()
    const slug = accountSlug ?? routeSlug ?? ''
    const flags = useSelector((state: State) => serverFlagsFromState(state, slug), shallowEqual)
    return capabilitiesFor(flags)
}
